import { Component } from '@angular/core';
import { TaskpaneComponent } from './taskpane/taskpane.component';

/**
 * Root shell for the Outlook task pane: a single screen, no router.
 * Avoids the History API (`replaceState`) that some Outlook hosts break inside iframes.
 */
@Component({
  selector: 'app-root',
  imports: [TaskpaneComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {}
